module.exports = __webpack_public_path__ + "assets/img/32_533.80d3678b.jpg";